// extracted by mini-css-extract-plugin
export default {"content":"Toast_content__-nMH+"};